import i18n from 'i18next';

export const getCodeErrorMessage = (code) => i18n.t([`errors:${code}`, '']);

export const API_ERRORS = {
	RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
	MODEL_NOT_FOUND: 'MODEL_NOT_FOUND',
	RESOURCE_NOT_ACTIVE: 'RESOURCE_NOT_ACTIVE',
	VIDEO_NOT_FOUND: 'VIDEO_NOT_FOUND',
	PROGRAM_NOT_FOUND: 'PROGRAM_NOT_FOUND',
	RESOURCE_NOT_AVAILABLE: 'RESOURCE_NOT_AVAILABLE',
	SUBSCRIBER_PARALLEL_STREAMS_LIMIT_EXCEEDED: 'SUBSCRIBER_PARALLEL_STREAMS_LIMIT_EXCEEDED',
	SUBSCRIBER_GROUP_STREAMS_LIMIT_EXCEEDED: 'SUBSCRIBER_GROUP_STREAMS_LIMIT_EXCEEDED',
	PROGRAM_BLACKOUT: 'PROGRAM_BLACKOUT',
	STARTOVER_NOT_ACTIVE_FOR_CHANNEL: 'STARTOVER_NOT_ACTIVE_FOR_CHANNEL',
	CATCHUP_NOT_ACTIVE_FOR_CHANNEL: 'CATCHUP_NOT_ACTIVE_FOR_CHANNEL',
	CATCHUP_NOT_AVAILABLE_FOR_PROGRAM: 'CATCHUP_NOT_AVAILABLE_FOR_PROGRAM',
	NPVR_NOT_ACTIVE_FOR_CHANNEL: 'NPVR_NOT_ACTIVE_FOR_CHANNEL',
	NPVR_NOT_AVAILABLE_FOR_PROGRAM: 'NPVR_NOT_AVAILABLE_FOR_PROGRAM',
	BLOCKED_BY_PARENTAL_CONTROL: 'BLOCKED_BY_PARENTAL_CONTROL',
	NOT_AVAILABLE_ON_PLATFORM: 'NOT_AVAILABLE_ON_PLATFORM',
	MUST_BE_IN_LOCAL: 'MUST_BE_IN_LOCAL',
	RESOURCE_NOT_IN_SUBSCRIBER_PRODUCTS: 'RESOURCE_NOT_IN_SUBSCRIBER_PRODUCTS',
	IP_BLACKLISTED: 'IP_BLACKLISTED',
	STB_CONNECTION_REFUSED: 'STB_CONNECTION_REFUSED',
	VIDEO_SESSION_INVALID: 'VIDEO_SESSION_INVALID',
	LIST_RECORDING_FAILURE_EXCEPTION: 'LIST_RECORDING_FAILURE_EXCEPTION',
	ADD_RECORDING_FAILURE_EXCEPTION: 'ADD_RECORDING_FAILURE_EXCEPTION',
	DELETE_RECORDING_EXCEPTION: 'DELETE_RECORDING_EXCEPTION',
	ACCOUNT_DETAILS_EXCEPTION: 'ACCOUNT_DETAILS_EXCEPTION',
	INVALID_API_DEVICE_HEADER: 'INVALID_API_DEVICE_HEADER',
	INVALID_PIN: 'INVALID_PIN',
	PIN_WRONG_OLD_PIN: 'PIN_WRONG_OLD_PIN',
	PIN_CANNOT_BE_EMPTY: 'PIN_CANNOT_BE_EMPTY',
	INVALID_PLATFORM: 'INVALID_PLATFORM',
	PLATFORM_MISSING: 'PLATFORM_MISSING',
	INVALID_UUID: 'INVALID_UUID',
	CANNOT_BUY_PRODUCT: 'CANNOT_BUY_PRODUCT',
	INVALID_PAYMENT_PIN: 'INVALID_PAYMENT_PIN',
	INVALID_PRICE_ENTRY: 'INVALID_PRICE_ENTRY',
	NOT_ENOUGH_CREDITS: 'NOT_ENOUGH_CREDITS',
	PRICE_ENTRY_OUT_OF_DATE: 'PRICE_ENTRY_OUT_OF_DATE',
	SGT_AUTHENTICATION_FAILED: 'SGT_AUTHENTICATION_FAILED',
	MISSING_EMAIL: 'MISSING_EMAIL',
	ESALES_SERVICE_UNAVAILABLE: 'ESALES_SERVICE_UNAVAILABLE',
	INVALID_SERIAL_NUMBER: 'INVALID_SERIAL_NUMBER',
	INVALID_ACCESS_KEY: 'INVALID_ACCESS_KEY',
	RECORDING_MAX_TIME_AVAILABLE_EXCEEDED_EXCEPTION: 'RECORDING_MAX_TIME_AVAILABLE_EXCEEDED_EXCEPTION',
	INVALID_PARENTAL_CONTROL_PIN: 'INVALID_PARENTAL_CONTROL_PIN',
	INVALID_PROFILE_ID_EXCEPTION: 'INVALID_PROFILE_ID_EXCEPTION',
	DEVICE_AUTHENTICATION_FAILED: 'DEVICE_AUTHENTICATION_FAILED',
	INVALID_PRODUCT_TYPE: 'INVALID_PRODUCT_TYPE',
	NDVR_CONNECTION_REFUSED: 'NDVR_CONNECTION_REFUSED',
	SUBSCRIBER_SUSPENDED_EXCEPTION: 'SUBSCRIBER_SUSPENDED_EXCEPTION',
	NO_ACCESS_TO_SYSTEM_EXCEPTION: 'NO_ACCESS_TO_SYSTEM_EXCEPTION',
	ESALES_ADDRESS_NOT_FOUND_EXCEPTION: 'ESALES_ADDRESS_NOT_FOUND_EXCEPTION',
	ESALES_EMAIL_NOT_FOUND_EXCEPTION: 'ESALES_EMAIL_NOT_FOUND_EXCEPTION',
	ESALES_OFFER_NOT_AVAILABLE: 'ESALES_OFFER_NOT_AVAILABLE',
	CANNOT_DETERMINE_SYSTEM: 'CANNOT_DETERMINE_SYSTEM',
	ESALES_AUTHENTICATION_FAILED_EXCEPTION: 'ESALES_AUTHENTICATION_FAILED_EXCEPTION',
	ESALES_DEVICE_NOT_FOUND: 'ESALES_DEVICE_NOT_FOUND',
	ESALES_CUSTOMER_NOT_FOUND_EXCEPTION: 'ESALES_CUSTOMER_NOT_FOUND_EXCEPTION',
	UNPROVISIONED_DEVICE: 'UNPROVISIONED_DEVICE',
	NOSERVICE_DEVICE: 'NOSERVICE_DEVICE',
	UNKNOWN_DEVICE: 'UNKNOWN_DEVICE',
	PARTNER_ERROR: 'PARTNER_ERROR',
	PADI_TOKEN_SERVICE_UNAVAILABLE: 'PADI_TOKEN_SERVICE_UNAVAILABLE',
	OPERATORS_PASSWORD_RESET_LINK_EXPIRED_EXCEPTION: 'OPERATORS_PASSWORD_RESET_LINK_EXPIRED_EXCEPTION',
	CANNOT_OVERWRITE_SUBSCRIBER_ID: 'CANNOT_OVERWRITE_SUBSCRIBER_ID',
	PUREOTT_SUBSCRIBER_EMAIL_NOT_CONFIRMED: 'PUREOTT_SUBSCRIBER_EMAIL_NOT_CONFIRMED',
	INVALID_SUBSCRIBER_SOURCE_EXCEPTION: 'INVALID_SUBSCRIBER_SOURCE_EXCEPTION',
	INVALID_SUBSCRIBER_LOGIN_CODE_EXCEPTION: 'INVALID_SUBSCRIBER_LOGIN_CODE_EXCEPTION',
	SEND_INVOICE_API_ERROR: 'SEND_INVOICE_API_ERROR',
	INVALID_PACKET_EXCEPTION: 'INVALID_PACKET_EXCEPTION',
	APPSTORE_INVALID_RESULT_CODE_EXCEPTION: 'APPSTORE_INVALID_RESULT_CODE_EXCEPTION',
	APPSTORE_MISSING_RESPONSE_DATA: 'APPSTORE_MISSING_RESPONSE_DATA',
	RECEIPT_SUBSCRIPTION_ALREADY_EXISTS: 'RECEIPT_SUBSCRIPTION_ALREADY_EXISTS',
	RECEIPT_SUBSCRIPTION_EXISTS_FOR_ANOTHER_USER: 'RECEIPT_SUBSCRIPTION_EXISTS_FOR_ANOTHER_USER',
	MISSING_EXTERNAL_ID_FOR_PRICE: 'MISSING_EXTERNAL_ID_FOR_PRICE',
	PAY_PAL_CANCEL_SUBSCRIPTION_EXCEPTION: 'PAY_PAL_CANCEL_SUBSCRIPTION_EXCEPTION',
	PAYPAL_SERVICE_CONNECTION_LOST: 'PAYPAL_SERVICE_CONNECTION_LOST',
	COUNTRY_ACCESS_DENIED: 'COUNTRY_ACCESS_DENIED',
	PAYMENT_ERROR: 'PAYMENT_ERROR',
	ERROR_WHILE_SAVING_TOPOLOGY_FILE: 'ERROR_WHILE_SAVING_TOPOLOGY_FILE',
	ERROR_WHILE_SAVING_PORTS_FILE: 'ERROR_WHILE_SAVING_PORTS_FILE',
	MAPPING_FILE_NOT_FOUND: 'MAPPING_FILE_NOT_FOUND',
	GOOGLE_RECAPTCHA_INVALID_TOKEN: 'GOOGLE_RECAPTCHA_INVALID_TOKEN',
	TOPOLOGY_SCHEMA_FILE_NOT_FOUND: 'TOPOLOGY_SCHEMA_FILE_NOT_FOUND',
	PORTS_SCHEMA_FILE_NOT_FOUND: 'PORTS_SCHEMA_FILE_NOT_FOUND',
	SUBSCRIBER_BLOCKED: 'SUBSCRIBER_BLOCKED',
	MYSQL_TIMEOUT_INVALID_CASE: 'MYSQL_TIMEOUT_INVALID_CASE',

	// DEVICES
	ADD_RECORDING_CONFLICTS: 'ADD_RECORDING_CONFLICTS',
	ADD_RECORDING_DISK_FULL: 'ADD_RECORDING_DISK_FULL',
	ADD_RECORDING_UNKNOWN_ERROR: 'ADD_RECORDING_UNKNOWN_ERROR',
	ACCOUNT_DETAILS_NOT_FOUND: 'ACCOUNT_DETAILS_NOT_FOUND',
	ACCOUNT_DETAILS_UNKNOWN_ERROR: 'ACCOUNT_DETAILS_UNKNOWN_ERROR',
	DELETE_RECORDING_NOT_FOUND: 'DELETE_RECORDING_NOT_FOUND',
	DELETE_RECORDING_WRONG_PIN: 'DELETE_RECORDING_WRONG_PIN',
	DELETE_RECORDING_UNKNOWN_ERROR: 'DELETE_RECORDING_UNKNOWN_ERROR',
	INVALID_ARGUMENT: 'INVALID_ARGUMENT',
	INVALID_ORDER_ID_EXCEPTION: 'INVALID_ORDER_ID_EXCEPTION',

	// LOGIN AUTH
	AUTHENTICATION_FAILED: 'AUTHENTICATION_FAILED',
	APP_CHECK_TOKEN_REQUIRED: 'APP_CHECK_TOKEN_REQUIRED',
	BEARER_TOKEN_REQUIRED: 'BEARER_TOKEN_REQUIRED',
	AUTHENTICATION_REQUIRED: 'AUTHENTICATION_REQUIRED',
	DEVICES_LIMIT_EXCEEDED: 'DEVICES_LIMIT_EXCEEDED',
	DEVICE_NOT_EXISTS: 'DEVICE_NOT_EXISTS',
	SUBSCRIBER_DEVICES_CHANGING_LIMIT_EXCEEDED: 'SUBSCRIBER_DEVICES_CHANGING_LIMIT_EXCEEDED',
	MULTIPLE_ACCOUNT_AVAILABLE: 'MULTIPLE_ACCOUNT_AVAILABLE',

	// LOGIN WITH EXTERNAL PROVIDER - unrelated account error messages
	SUBSCRIBER_EXTERNAL_PROVIDER_RECORD_NOT_FOUND: 'SUBSCRIBER_EXTERNAL_PROVIDER_RECORD_NOT_FOUND',

	// PROMOTIONS
	CANNOT_USE_PROMOTION: 'CANNOT_USE_PROMOTION',
	INVALID_PROMOTION_CODE: 'INVALID_PROMOTION_CODE',

	// REGISTRATION
	RESOURCE_ALREADY_EXISTS: 'RESOURCE_ALREADY_EXISTS',
	PUREOTT_SUBSCRIBER_ACCOUNT_SUSPENDED: 'PUREOTT_SUBSCRIBER_ACCOUNT_SUSPENDED',
	PUREOTT_SUBSCRIBER_WRONG_CREDENTIALS: 'PUREOTT_SUBSCRIBER_WRONG_CREDENTIALS',
	PUREOTT_SUBSCRIBER_EMAIL_APPROVE_EXPIRED: 'PUREOTT_SUBSCRIBER_EMAIL_APPROVE_EXPIRED',
	PUREOTT_SUBSCRIBER_NOT_FOUND: 'PUREOTT_SUBSCRIBER_NOT_FOUND',

	// LOGIN WITH CODE
	SUBSCRIBER_LOGIN_CODE_EXPIRED: 'SUBSCRIBER_LOGIN_CODE_EXPIRED',
	DEVICE_LIMIT_EXCEEDED_EXCEPTION: 'DEVICE_LIMIT_EXCEEDED_EXCEPTION',
	DEVICE_CHANGES_LIMIT_EXCEEDED_EXCEPTION: 'DEVICE_CHANGES_LIMIT_EXCEEDED_EXCEPTION',
	OUTSIDE_OF_POLAND: 'OUTSIDE_OF_POLAND',
	OUTSIDE_OF_EOG: 'OUTSIDE_OF_EOG',
	PAYMENT_ALREADY_EXISTS: 'PAYMENT_ALREADY_EXISTS',
	PACKETS_SUBSCRIPTION_ALREADY_EXIST: 'PACKETS_SUBSCRIPTION_ALREADY_EXIST'
};

export const ERROR_CODE_API_STATUS = {
	500: i18n.t('error_connection'),
	502: i18n.t('error_portal_unavailable'),
	422: i18n.t('error_invalid_data')
};

export const getErrorCodeResults = (error) => {
	const data = error?.response?.data;

	if (!data) return { codeErrorMessage: '', errorCode: '' };

	const { message, errorCode, status } = data;

	const codeErrorMessage = getCodeErrorMessage(errorCode) || ERROR_CODE_API_STATUS[status] || message;

	return { codeErrorMessage, errorCode };
};

export const getErrorStatus = (status) => ERROR_CODE_API_STATUS[status] ?? i18n.t('common_errors_default_error');

export const CUSTOM_ERROR = {
	//Mock error for player parental control
	CUSTOM_PARENTAL_CONTROL_ERROR: {
		response: {
			data: {
				isError: true,
				code: 400,
				message: getCodeErrorMessage(API_ERRORS.BLOCKED_BY_PARENTAL_CONTROL),
				errorCode: API_ERRORS.BLOCKED_BY_PARENTAL_CONTROL
			}
		}
	},
	//Mock error for player end of program in program details
	CUSTOM_END_OF_PROGRAM: {
		response: {
			data: {
				isError: true,
				code: 400,
				message: i18n.t('error_end_of_program'),
				errorCode: 'END_OF_PROGRAM'
			}
		}
	},
	CUSTOM_REQUEST_INVALID_DATA: i18n.t('error_invalid_data'),
	CUSTOM_INVALID_VAT_NUMBER: i18n.t('error_invalid_nip'),
	CHECK_HASH_CUSTOM_CODE: i18n.t('error_hash_status'),
	BROWSER_NOT_SUPPORTED: i18n.t('player_error_browser_not_supported'),
	SHAKA_PLAYER_ERROR_MESSAGE: i18n.t('dictionary:player_error_shaka_player_error_message')
};

// HTTP response status codes
export const HTTP_STATUS_CODES = {
	NOT_ACCEPTABLE: 406
};
